import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse('01234567890123456789012345678901'); // 32바이트 키
const iv = CryptoJS.enc.Utf8.parse('0123456789012345'); // 16바이트 IV

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // Base64 인코딩
}

export function decrypt(cipherText) {
  const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}